import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppSettings } from "../../config/config";
import { map } from 'rxjs/operators';

@Injectable()
export class StudentBasicInfoService {

  private _url = AppSettings.API_ENDPOINT;
  constructor(private http: HttpClient) {
  }

  updateStudentInfo(AUTHTOKEN, studentId, file, imageFor) {
    let ImageUploadData = new FormData();
    if (imageFor === "aadharReference") {
      ImageUploadData.append('aadharReference', file);
    }
    else if (imageFor === "tcOrBirthCertificate") {
      ImageUploadData.append('tcOrBirthCertificate', file);
    }
    else if (imageFor === "casteCertificate") {
      ImageUploadData.append('casteCertificate', file);
    }
    else if (imageFor === "ewsCertificate") {
      ImageUploadData.append('ewsCertificate', file);
    }
    else if (imageFor === "singleGirlChildCertificate") {
      ImageUploadData.append('singleGirlChildCertificate', file);
    }
    else if (imageFor === "speciallyAbled") {
      ImageUploadData.append('speciallyAbled', file);
    }
    else {
      ImageUploadData.append('image', file);
    }
    let headers = new HttpHeaders().append("enctype", 'multipart/form-data').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/upload/image?userType=STUDENT&userId=' + studentId,
      ImageUploadData, { headers: headers })
      .pipe(map(res => res));
  }

  getStudentDetailsForEditForm(studentId, AUTHTOKEN) {
    let params = { studentId: studentId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/studentlist/studentbasicinfoedit',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  getClassStandardsByCategory(categoryId, AUTHTOKEN) {
    let params = { categoryId: categoryId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/studentlist/getClassStandardsByCategoryV2',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  getClassSectionsByClassIdFun(classStandardId, AUTHTOKEN) {
    let params = { classStandardId: classStandardId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/studentlist/getClassSectionsByClassIdFunV2',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  studentClassChangeValidation(newClassId, oldClassId, studentId, AUTHTOKEN) {
    let params = { newClassId: newClassId, oldClassId: oldClassId, studentId: studentId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/studentlist/studentClassChangeValidation',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  //update student details
  updateStudentDetails(studentBasicInfo, AUTHTOKEN) {
    let params = studentBasicInfo;
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this._url + '/addstudent/updatestudentbasicinfo',
      params, { headers: headers })
      .pipe(map(res => res));
  }

  //fetch school houses
  getSchoolHouseList(AUTHTOKEN) {
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.get(this._url + '/studentlist/schoolhouselist', { headers: headers })
      .pipe(map(res => res));
  }

  removeStudentProfilePic(AUTHTOKEN, studentId) {
    let params = { studentId: studentId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.put(this._url + '/studentlist/removeProfilePic',
      params, { headers: headers })
      .pipe(map(res => res));
  }
}